import { c as _c } from "react/compiler-runtime";
import { getVerticalTabsStyles } from "@components/common/tabs/vertical-tabs-style";
import { Grid } from "@mui-wrapper";
import { BaseSettingsPage } from "@pages/settings/base-settings-page";
import { FontWeights } from "@flat-ui";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_INPUT_FONT_SIZE, DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { TabItem } from "@components/common/tabs/tab-item";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * A general component which generates vertical tabs.
 * The MUI vertical tabs are not used because it is unnecessary complicated for our purpose
 */
export function VerticalTabs(t0) {
  const $ = _c(30);
  const {
    tabs,
    tabSelectionHeader,
    isLoading,
    selectedTabId,
    trackingEventPageName,
    dataTestId
  } = t0;
  const selectedTab = tabs[selectedTabId];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVerticalTabsStyles();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    tabListSection,
    tabContentSection
  } = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "flex-end",
      flexWrap: "nowrap"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderBottom: `1px solid ${PALETTE_VARS.divider}`,
      pb: "10px",
      mr: tabListSection.mr,
      ml: "0px",
      width: tabListSection.width,
      fontSize: DEFAULT_TEXT_FONT_SIZE,
      letterSpacing: "0.48px",
      textTransform: "uppercase",
      fontWeight: FontWeights.Bold
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== tabSelectionHeader) {
    t4 = <Grid sx={t3}>{tabSelectionHeader}</Grid>;
    $[3] = tabSelectionHeader;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      borderBottom: `1px solid ${PALETTE_VARS.divider}`,
      pb: "10px",
      width: tabContentSection.width,
      mr: "0px",
      fontSize: "24px",
      fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== selectedTab.label) {
    t6 = <Grid sx={t5}>{selectedTab.label}</Grid>;
    $[6] = selectedTab.label;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <Grid container={true} sx={t2}>{t4}{t6}</Grid>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      mt: "40px",
      flexWrap: "nowrap"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mr: tabListSection.mr,
      ml: "0px",
      width: tabListSection.width,
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      textTransform: "uppercase",
      fontWeight: FontWeights.Bold
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== tabs) {
    t10 = Object.values(tabs);
    $[13] = tabs;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== selectedTab.label || $[16] !== t10 || $[17] !== trackingEventPageName) {
    t11 = <Grid sx={t9}>{t10.map(tab => <TabItem key={tab.label} label={tab.label} routeId={tab.routeId} isHidden={tab.isHidden} content={tab.content} isSelected={selectedTab.label === tab.label} trackingEventPageName={trackingEventPageName} />)}</Grid>;
    $[15] = selectedTab.label;
    $[16] = t10;
    $[17] = trackingEventPageName;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      width: tabContentSection.width,
      mr: "0px"
    };
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== dataTestId || $[21] !== isLoading || $[22] !== selectedTab.content) {
    t13 = <Grid sx={t12}><BaseSettingsPage pageSectionProps={selectedTab.content} isLoading={isLoading} dataTestId={dataTestId} /></Grid>;
    $[20] = dataTestId;
    $[21] = isLoading;
    $[22] = selectedTab.content;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t13) {
    t14 = <Grid container={true} sx={t8}>{t11}{t13}</Grid>;
    $[24] = t11;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t7) {
    t15 = <Grid container={true}>{t7}{t14}</Grid>;
    $[27] = t14;
    $[28] = t7;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
}